import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { useScope } from "@/context/ScopeContext";

const BASE = process.env.REACT_APP_BACKEND_URL;
const BASE_RGB = "249, 249, 247"; // matches --bg cream

function resolve(url) {
  if (!url) return "";
  return url.startsWith("/") ? `${BASE}${url}` : url;
}

export function BackgroundManager() {
  const { user } = useAuth();
  const { scope } = useScope();
  const backgrounds = user?.backgrounds || {};
  const bg = backgrounds[scope] || backgrounds.all || null;
  const active = bg && bg.type && bg.type !== "none";

  // Body class + text color vars only (no body background-image = no scroll flicker)
  useEffect(() => {
    const body = document.body;
    if (active) body.classList.add("has-app-bg");
    else body.classList.remove("has-app-bg");
    if (bg?.text_mode === "light") {
      body.style.setProperty("--text", "#f5f5f2");
      body.style.setProperty("--text-2", "rgba(245,245,242,0.72)");
    } else if (bg?.text_mode === "dark") {
      body.style.setProperty("--text", "#1a1a18");
      body.style.setProperty("--text-2", "#5c5c59");
    } else {
      body.style.removeProperty("--text");
      body.style.removeProperty("--text-2");
    }
  }, [active, bg?.text_mode]);

  if (!active) return null;

  const scrim = (100 - (bg.opacity ?? 100)) / 100;
  const veil = `linear-gradient(rgba(${BASE_RGB}, ${scrim}), rgba(${BASE_RGB}, ${scrim}))`;
  const style = {
    position: "fixed",
    inset: 0,
    zIndex: -1,
    pointerEvents: "none",
    backgroundColor: "#f9f9f7",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  };
  if (bg.type === "color") {
    style.backgroundColor = bg.value || "#f9f9f7";
    style.backgroundImage = veil;
  } else if (bg.type === "image") {
    style.backgroundImage = `${veil}, url("${resolve(bg.value)}")`;
  }
  return <div aria-hidden="true" data-testid="app-bg-layer" style={style} />;
}
